import { render, staticRenderFns } from "./hotelLogDetails.vue?vue&type=template&id=50fdf125&scoped=true&"
import script from "./hotelLogDetails.vue?vue&type=script&lang=js&"
export * from "./hotelLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./hotelLogDetails.vue?vue&type=style&index=0&id=50fdf125&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fdf125",
  null
  
)

export default component.exports